<template>
    <FormulateInput
        :name="field.name"
        :label="field.label"
        :help="field.help"
        :id="id"
        :validation-name="field.label"
        type="proposal"
        validation="required">
        <template #label><slot name="label"></slot></template>
        <template #help><slot name="help"></slot></template>
    </FormulateInput>
</template>

<script>

export default {
    name: "ProposalInput",
    props: {
        id: {
            type: String,
            required: true
        },
        field: Object
    },
    data() {
        return {};
    }
}
</script>

<style scoped>

</style>
